import { SideNavItems, SideNavSection } from '@modules/navigation/models';

export const sideNavSections: SideNavSection[] = [
    {
        items: ['assistant', 'dashboards', 'pos', 'inventario', 'bankAccounts', 'expenses', 'financialSummary', 'marketing', 'statistics', 'bankProducts'],
    },
];

export const configSection: SideNavSection = {
    text: 'CONFIGURACIÓN',
    items: ['comercio', 'help'],
};

export const sideNavItems: SideNavItems = {
    assistant: {
        icon: 'zap',
        text: 'Asistente IA',
        link: '/asistente',
        new: true,
    },
    dashboards: {
        icon: 'home',
        text: 'Home',
        link: '/dashboard',
    },
    pos: {
        icon: 'shopping-cart',
        text: 'Pedidos',
        tourId: 'make_first_sale',
        submenu: [
            {
                text: 'Nuevo pedido',
                link: '/pos/direct-sales',
            },
            {
                text: 'Mesas',
                link: '/pos/open-sales',
            },
            {
                text: 'Cashea Link',
                link: '/pos/cashea-link',
            },
            {
                text: 'Precios de Venta',
                link: '/pos/sales-channels-new',
                dataTour: 'sidebar-precios-venta',
            },
            {
                text: 'Registros de pedidos',
                link: '/pos/sales-registries',
                dataTour: 'sidebar-pedidos',
            },
            {
                text: 'Cotizaciones',
                link: '/pos/cotizaciones',
                new: true,
            },
            {
                text: 'Caja',
                link: '/pos/cashboxes-registries',
            },
        ],
    },
    inventario: {
        icon: 'package',
        text: 'Inventario',
        tourId: 'add_first_product',
        submenu: [
            {
                text: 'Inventario',
                link: '/inventario/general',
            },
            {
                text: 'Recetas/Combos',
                link: '/inventario/productos-combinados',
                dataTour: 'sidebar-recetas-combos',
            },
            {
                text: 'Servicios',
                link: '/inventario/servicios',
            },
            {
                text: 'Registros',
                submenu: [
                    {
                        text: 'General',
                        link: '/inventario/registros/general',
                    },
                    {
                        text: 'Entradas',
                        link: '/inventario/registros/entradas',
                    },
                    {
                        text: 'Salidas',
                        link: '/inventario/registros/salidas',
                    },
                ],
            },
            {
                text: 'Historial de Traslados',
                link: '/inventario/historial-traslados',
            },
        ],
    },
    bankAccounts: {
        icon: 'credit-card',
        text: 'Cuentas',
        tourId: 'create_and_fund_account',
        submenu: [
            {
                text: 'Cuentas bancarias',
                link: '/accounts/bank-accounts',
            },
            {
                text: 'Cuentas por cobrar/pagar',
                link: '/accounts/pending-accounts',
                activeFor: ['/accounts/pending-accounts-history'],
            },
            {
                text: 'Historial',
                link: '/accounts/history',
            },
        ],
    },
    expenses: {
        icon: 'file-text',
        text: 'Gastos',
        link: '/expenses',
        dataTour: 'sidebar-gastos',
    },
    financialSummary: {
        icon: 'book',
        text: 'Resumen Financiero',
        submenu: [
            {
                text: 'Utilidad/Perdida',
                link: '/financial-summary/utility-loss',
            },
            {
                text: 'Reportes',
                link: '/financial-summary/daily-reports',
            },
        ],
    },
    marketing: {
        icon: 'activity',
        text: 'Marketing',
        submenu: [
            {
                text: 'Clientes',
                link: '/marketing/customers',
            },
            {
                text: 'Campañas',
                link: '/marketing/campaign',
            },
        ],
    },
    statistics: {
        icon: 'bar-chart',
        text: 'Estadísticas',
        link: '/statistics',
    },
    bankProducts: {
        icon: 'credit-card',
        text: 'Fina Presta',
        link: '/creditos/general',
        new: true,
    },
    comercio: {
        icon: 'settings',
        text: 'Configuración',
        submenu: [
            {
                text: 'Mi usuario',
                link: '/cuenta',
            },
            {
                text: 'Preferencias',
                link: '/comercio/preferencias',
            },
            {
                text: 'Usuarios asociados',
                link: '/comercio/usuarios-asociados',
                dataTour: 'sidebar-usuarios-asociados',
            },
            {
                text: 'Cargos extra en pedidos',
                link: '/comercio/staff',
                dataTour: 'sidebar-cargos-extra',
            },
            {
                text: 'Códigos de descuento',
                link: '/comercio/discounts',
            },
            {
                text: 'Planes',
                link: '/comercio/plans',
            },
            {
                text: 'Cierre de caja',
                link: '/comercio/cashbox',
                dataTour: 'sidebar-cierre-caja',
            },
            {
                // Recaudos fiscal v2: onboarding a Facturación Digital. Visible solo con el feature
                // flag `fiscal-recaudos` (lo decide hideTab en side-nav-item-pro, igual que la ruta);
                // el badge de estado («En revisión», «Falta tu firma»…) lo pinta el mismo ítem.
                text: 'Fiscal',
                link: '/fiscal',
            },
        ],
    },
    help: {
        icon: 'help-circle',
        text: 'Centro de ayuda',
        link: 'https://intercom.help/finapartner/es',
        target: '_blank',
    },
};
